"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterData = void 0;
class FilterData {
    constructor() {
        this.currentPage = 0;
        this.data = new Map();
        this.selectedFilters = new Set();
    }
}
exports.FilterData = FilterData;
//# sourceMappingURL=filters-menu-data.js.map